import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

/**
 * Inverse of RequireRole: keeps super admins OUT of merchant-only screens.
 *
 * Onboarding is the case this exists for. An admin account has no business
 * profile, no plan to pick and no test payment to make, so the wizard has
 * nothing to ask them -- but every post-login redirect pointed at /onboarding
 * regardless of role, so admins were walked through merchant setup.
 *
 * Guarding the route rather than the login redirect covers the deep links too:
 * /onboarding/business typed straight into the address bar lands here as well.
 */
const RequireMerchant = ({ children }) => {
  const { user } = useSelector((state) => state.auth);
  const isSuperAdmin = user?.role_id === 1 || user?.roleId === 1;
  return isSuperAdmin ? <Navigate to="/dashboard" replace /> : children;
};

export default RequireMerchant;
